import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=166bace7&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=166bace7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166bace7",
  null
  
)

export default component.exports